import React, { useState } from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import logo from "../asset/logowhite.png";
import SummaryApi from "../common/index";
import {
  FaUser,
  FaBook,
  FaChalkboardTeacher,
  FaCalendarAlt,
  FaClock,
  FaCheckCircle,
  FaMoneyBillWave,
  FaAward,FaSearch, FaShieldAlt, FaArrowLeft
} from "react-icons/fa";

const CertificateVerification = () => {
  const [certificateId, setCertificateId] = useState("");
  const [verificationResult, setVerificationResult] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [certificateData, setCertificateData] = useState(null);

const handleVerify = async () => {
  if (!certificateId.trim()) {
    setVerificationResult("Please enter a certificate number.");
    return;
  }

  setIsVerifying(true);
 setVerificationResult(null);
  setCertificateData(null);

  try {
    const payload = {
      certificate_number: certificateId.trim()
    };

    // Use the correct API endpoint for certificate verification
    const response = await fetch(SummaryApi.verifycertificationbyid.url, {
      method: SummaryApi.verifycertificationbyid.method, // This should be POST
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.status === true) {
      setCertificateData(result.data);
    } else {
      setVerificationResult(result.message || "Invalid certificate number. Please check and try again.");
    }
  } catch (error) {
    console.error("Verification error:", error);
    setVerificationResult("An error occurred while verifying the certificate. Please try again.");
  } finally {
    setIsVerifying(false);
  }
};

  return (
    <div className="min-h-screen flex flex-col dark:bg-gray-900 relative">
      <button
        onClick={() => window.history.back()}
        className="fixed top-24 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700 lg:hidden"
        aria-label="Go back"
      >
        <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
      </button>

      {/* Top Blue Section */}
      <div className="bg-[#103b6b] dark:bg-gray-800 text-white text-center pt-20 pb-12 px-4 rounded md:pt-14">
        <div className="flex justify-center mb-4 text-[#66cc00] text-8xl">
          <IoMdCheckmarkCircleOutline />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold mb-4 font-inter">
          Certificate Verification
        </h1>
        <p className="text-[22px] md:text-base max-w-3xl mx-auto text-gray-200 font-inter">
          Verify the authenticity of certificates issued by Skillara. Enter the
          certificate ID below to confirm legitimacy and view certificate details.
        </p>
      </div>

      {/* Input Section */}
      <div className="bg-[#f7f7f9] dark:bg-gray-900 w-full flex justify-center px-4 py-16">
        <div className="w-full max-w-6xl bg-white dark:bg-gray-800 shadow-md rounded-md overflow-hidden">
          <div className="bg-[#103b6b] dark:bg-gray-700 text-white text-center py-6">
            <h2 className="text-2xl font-semibold">Enter Certificate Number</h2>
          </div>
          <div className="px-6 py-8 mx-auto">
      <div className="flex flex-col sm:flex-row items-center gap-4">
    <input
      type="text"
      placeholder="Enter certificate number"
      className="flex-1 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
      value={certificateId}
      onChange={(e) => setCertificateId(e.target.value)}
      disabled={isVerifying}
    />
<button
  onClick={handleVerify}
  disabled={isVerifying}
  className={`bg-[#1C3664] dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600 text-white px-6 py-3 rounded-md transition flex items-center ${
    isVerifying ? "opacity-70 cursor-not-allowed" : ""
  }`}
>
  {isVerifying ? (
    <span className="flex items-center gap-2">
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
      Verifying...
    </span>
  ) : (
    "Verify Certificate"
  )}
</button>

  </div>
          </div>
{verificationResult && !certificateData && (
    <div className="mt-6">
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-6 flex items-center justify-center">
        <div className="flex flex-col items-center text-center">
          <div className="text-4xl text-red-500 dark:text-red-400 mb-4">
            <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="text-lg font-semibold text-red-800 dark:text-red-200">
            Certificate Not Found
          </div>
          <div className="text-red-700 dark:text-red-300 mt-2">
            {verificationResult}
          </div>
        </div>
      </div>
    </div>
  )}

{certificateData && (
  <div className="px-6 pb-8">
    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-6">

      {/* HEADER */}
      <div className="text-center mb-8">
        <div className="text-2xl font-semibold text-green-800 dark:text-green-200 mb-1">
          Certificate Verified Successfully
        </div>
        <div className="text-sm text-green-700 dark:text-green-300">
          Certificate Number {certificateData.certificate_number}
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="max-w-3xl mx-auto space-y-4">

        {/* STUDENT NAME */}
        <div className="flex items-center gap-3">
          <FaUser className="text-blue-600 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Student Name</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
          <span className="font-semibold text-gray-900 dark:text-white">{certificateData.student_name}</span>
        </div>

        {/* COURSE NAME */}
        <div className="flex items-center gap-3">
          <FaBook className="text-purple-600 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Course Name</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
          <span className="font-semibold text-gray-900 dark:text-white">{certificateData.course_title}</span>
        </div>

        {/* INSTRUCTOR */}
        <div className="flex items-center gap-3">
          <FaChalkboardTeacher className="text-green-600 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Instructor Name</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
          <span className="font-semibold text-gray-900 dark:text-white">{certificateData.instructor_name}</span>
        </div>

        {/* BATCH DETAILS */}
        <div className="flex items-center gap-3">
          <FaClock className="text-orange-600 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Batch Details</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
    <span className="font-semibold text-gray-900 dark:text-white">
  {new Date(certificateData.enrollment_date).toLocaleDateString("en-GB")} —{" "}
  {certificateData.time_slot.replace(/^.*?,\s*-/, "").trim()}
</span>

        </div>

        {/* ENROLLMENT DATE */}
        <div className="flex items-center gap-3">
          <FaCalendarAlt className="text-yellow-600 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Enrollment Date</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
          <span className="font-semibold text-gray-900 dark:text-white">
            {new Date(certificateData.enrollment_date).toLocaleDateString("en-GB")}
          </span>
        </div>

        {/* STATUS */}
        <div className="flex items-center gap-3">
          <FaCheckCircle className="text-indigo-600 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Enrollment Status</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
          <span className="font-semibold text-gray-900 dark:text-white">{certificateData.enrollment_status}</span>
        </div>


        {/* COMPLETION */}
        <div className="flex items-center gap-3">
          <FaAward className="text-green-700 text-xl" />
          <span className="w-48 font-medium text-gray-700 dark:text-gray-300">Course Completion</span>
          <span className="font-medium text-gray-700 dark:text-gray-300">:</span>
          <span className="font-semibold text-green-700 dark:text-green-400">
            Completed on {new Date(certificateData.course_completed_date).toLocaleDateString("en-GB")}
          </span>
        </div>

      </div>
    </div>
  </div>
)}



        </div>
      </div>

      {/* Rest of the existing code remains unchanged */}
      <div className="w-full bg-[#f7f7f9] dark:bg-gray-900 pb-12">
        <div className="max-w-6xl mx-auto rounded-lg shadow bg-white dark:bg-gray-800">
          <h2 className="text-2xl font-semibold text-center mb-10 text-white bg-[#103b6b] dark:bg-gray-700 p-6 rounded-lg shadow">
            How Certificate Verification Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-4 md:px-0">
            <div className="flex flex-col items-center text-center bg-white dark:bg-gray-700 p-6 rounded-lg">
              <div className="bg-blue-100 dark:bg-blue-900 rounded-full p-4 flex items-center justify-center w-20 h-20">
                <FaSearch className="text-3xl text-blue-900 dark:text-blue-300" />
              </div>
              <h3 className="font-semibold text-lg text-blue-900 dark:text-white mb-2">Enter Certificate ID</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm font-inter">Input the unique certificate number</p>
            </div>
            <div className="flex flex-col items-center text-center bg-white dark:bg-gray-700 p-6 rounded-lg">
              <div className="bg-blue-100 dark:bg-blue-900 rounded-full p-4 flex items-center justify-center w-20 h-20">
                <FaShieldAlt className="text-3xl text-blue-900 dark:text-blue-300" />
              </div>
              <h3 className="font-semibold text-lg text-blue-900 dark:text-white mb-2">Verify Authenticity</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm font-inter">Our system checks the certificate against our secure database</p>
            </div>
            <div className="flex flex-col items-center text-center bg-white dark:bg-gray-700 p-6 rounded-lg">
              <div className="bg-blue-100 dark:bg-blue-900 rounded-full p-4 flex items-center justify-center w-20 h-20">
                <FaCheckCircle className="text-3xl text-blue-900 dark:text-blue-300" />
              </div>
              <h3 className="font-semibold text-lg text-blue-900 dark:text-white mb-2">Get Results</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm font-inter">Instantly view certificate details and verification status</p>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action - remains unchanged */}
      <div className="bg-blue-900 dark:bg-gray-800 text-white py-12 text-center">
        <div className="w-[40%] mx-auto md:w-[18%]">
          <img src={logo} alt="logo" className="" />
        </div>
        <h2 className="text-3xl font-bold text-blue-200 dark:text-blue-300 mb-2">Enroll, Learn, Grow, Repeat!</h2>
        <p className="text-lg mb-6">Get ready to achieve your learning goals with Skillara</p>
        <a href="/all-courses" className="bg-blue-600 dark:bg-blue-700 hover:bg-blue-500 dark:hover:bg-blue-600 transition text-white px-6 py-3 rounded font-semibold">
          View All Premium Courses →
        </a>
      </div>
    </div>
  );
};

export default CertificateVerification;